import React from "react";
import { useDropzone } from "react-dropzone";

const FileUploader = ({
	onFilesAdded,
	setErrorOccured,
	multiple,
	disabled,
}) => {
	const { getRootProps, getInputProps } = useDropzone({
		accept: { "application/pdf": [] }, // Correctly define MIME types
		onDrop: (acceptedFiles) => {
			onFilesAdded(acceptedFiles);
		},
		multiple: multiple,
		disabled: disabled,
		onError: (err) => {
			setErrorOccured(err);
		},
	});

	return (
		<div
			{...getRootProps()}
			className="border-[2px] border-dashed border-[#333] p-5 h-[150px] flex flex-col items-center justify-center cursor-pointer"
		>
			<input {...getInputProps()} />
			<p>Drag & drop PDF files here </p>
			<p>Or</p>
			<p>Click to Select Files</p>
		</div>
	);
};

export default FileUploader;
